export const formatNumber = (
  value: number | null | undefined,
  maximumFractionDigits = 2
): string | null | undefined => {
  if (value == null) {
    return value;
  }

  return new Intl.NumberFormat('ru-RU', { useGrouping: false, maximumFractionDigits }).format(value);
};
